import React from 'react';

const TarjetaNumeroRow = ({isChildRow, tarjeta, numero}) => {

    if (isChildRow) {
        return (
            <div>
                <p className="AcountLink RowNumberChild">{tarjeta.toUpperCase()}</p>
                <p className="RowNumberText">{numero}</p>
            </div>
        );
    }
    else {
        return <p className="AcountLink">{numero}</p>;
    }

}


export default TarjetaNumeroRow;
